import { getSelectedVariant, isVariantAvailable } from '../utils/product-utils'
import { returnArrayOrNull, returnObjectOrNull } from '@surf-turf/nemo/assets/utils-type-check'
import addButton from './add-button-state'
import { getAllVariantDataObjectsFromUrl } from '../utils/inputs'
import { getValueFromUrl } from '../utils/url'

const productForm = document.querySelector('product-form')

/**
 * Get correct variant by variant id.
 *
 * @param {object} allVariants \
 * @param {number} correctVariantId
 *
 * @returns
 */
export const getCorrectVariantById = (allVariants, correctVariantId) =>
  returnObjectOrNull(allVariants.find((variant) => Number(Number(variant.id) == correctVariantId)))

/**
 * Get pricing product by variant id.
 *
 * @param {HTMLElement} allVariantsElement
 * @param {string} variantId
 *
 * @returns {number}
 */
export const getPricingProductByVariantId = (allVariantsElement, correctVariantId) => {
  const allProductVariants = allVariantsElement ? JSON.parse(allVariantsElement.innerHTML).variants : null
  const correctVariantObject = getCorrectVariantById(allProductVariants, correctVariantId)

  if (correctVariantObject) {
    const price = correctVariantObject.price
    const compareAtPrice = correctVariantObject.compareAtPrice ? correctVariantObject.compareAtPrice : null

    return returnObjectOrNull({
      price: price,
      compareAtPrice: compareAtPrice ? compareAtPrice : null,
    })
  }
}

/**
 * Get price from variant object.
 *
 * @param {object} variantObject
 *
 * @returns {object|null}
 */
export const getPriceFromVariantObject = (variantObject) => {
  if (variantObject) {
    const price = variantObject.price || 0
    const compareAtPrice = variantObject.compareAtPrice ? variantObject.compareAtPrice : null

    // Check if their is a quanity selector in the product form. If there is multiply the pricing by that value.
    const fieldsetElement = productForm.querySelector('fieldset[name="quantity"]')
    const selectedInput = fieldsetElement ? fieldsetElement.querySelector('input:checked') : null
    const quantityValue = selectedInput ? selectedInput.dataset.value : 1

    let pairingValue = 1

    // Check if the pairing fieldset is set to pair.
    // const pairingFieldsetElement = productForm.querySelector('fieldset[name="pairing"]')
    // const pairingSelectedInput = pairingFieldsetElement ? pairingFieldsetElement.querySelector('input:checked') : null
    if (variantObject.title?.includes('Pair')) {
      // Do nothing, the variant has a single and pair variant so we don't need to multiply the price.
    } else {
      const pairingUrlValue = getValueFromUrl('pairing')

      pairingValue = pairingUrlValue == 'pair' ? 2 : 1
    }

    return returnObjectOrNull({
      price: Number(price) * Number(quantityValue) * Number(pairingValue),
      compareAtPrice: compareAtPrice ? Number(compareAtPrice) * Number(quantityValue) * Number(pairingValue) : null,
      quantity: quantityValue,
      pairing: pairingValue,
    })
  }
}

/**
 * Get price of main product.
 *
 * @returns {object|null}
 */
export const getPriceOfMainProduct = () => {
  const mainProductVariantObject = getAllVariantDataObjectsFromUrl()
  const pricing = getPriceFromVariantObject(mainProductVariantObject?.mainProduct)

  return returnObjectOrNull(pricing)
}

/**
 *? Get price of connected products.
 *
 * @returns {array|null}
 */
export const getPriceOfConnectedProducts = () => {
  const allVariantDataObjectsFromUrl = getAllVariantDataObjectsFromUrl()
  const allConnectedProductVariantObjects = allVariantDataObjectsFromUrl?.connectedProducts
  const connectedProductPricingArray = allConnectedProductVariantObjects?.map((connectedProductVariantDataObject) => ({
    connectedProductId: connectedProductVariantDataObject.connectedProductId,
    ...getPriceFromVariantObject(connectedProductVariantDataObject),
  }))

  return returnArrayOrNull(connectedProductPricingArray)
}

/**
 * Get total price of products on page.
 *
 * @returns {object}
 */
export const getPricingObject = () => {
  const mainProductPrice = getPriceOfMainProduct()
  const connectedProductsPrice = getPriceOfConnectedProducts()

  let totalPriceConnectedProducts = null
  let compareAtPrice = null

  if (mainProductPrice?.compareAtPrice && connectedProductsPrice?.compareAtPrice) {
    compareAtPrice = Number(mainProductPrice?.compareAtPrice) + Number(connectedProductsPrice?.compareAtPrice)
  }

  if (connectedProductsPrice) {
    totalPriceConnectedProducts = connectedProductsPrice.reduce((previousPrice, currentPrice) => ({ price: previousPrice.price + currentPrice.price }))
  }

  const totalPrice = Number(mainProductPrice?.price) + (totalPriceConnectedProducts?.price ? Number(totalPriceConnectedProducts?.price) : 0)

  return {
    mainProductPrice,
    connectedProductsPrice,
    total: {
      price: totalPrice,
      compareAtPrice: compareAtPrice,
    },
  }
}

/**
 * is the selected variant available
 */
export const handleSelectedVariantAvailability = () => {
  const variant = getSelectedVariant()

  if (variant === null) {
    // Set button to disabled.
    addButton.setMakeSelection()
  } else {
    if (isVariantAvailable(variant)) {
      // Set button to active.
      addButton.setActive()
    } else {
      // Set button to disabled.
      addButton.setDisabled()
    }
  }
}

/**
 * Handle quantity selector.
 */
export const handleQuantity = () => {
  const productQuantityElement = document.querySelector('.product-quantity')

  // If there is no quantity selector don't set the event listener.
  if (productQuantityElement) {
    productQuantityElement.addEventListener('change', handleNewQuantityPrice)
  }
}

/**
 * Update price in submit button
 */
export const handleNewQuantityPrice = () => {
  // Get variant.
  const variant = getSelectedVariant()

  // Get value of quantity selector (if there is one)
  const quantityElement = document.querySelector('.product-quantity')
  let defaultQuantity = 1

  if (quantityElement) {
    const quantitySelectElement = quantityElement.querySelector('select')
    const quantityValue = quantitySelectElement ? quantitySelectElement.value : null

    if (quantityValue === null) {
      // Do nothing.
    } else {
      defaultQuantity = quantityValue
    }
  }

  if (variant) {
    // Get price of variant.
    const compareAtPrice = variant.compare_at_price ? variant.compare_at_price : null
    const price = variant.price ? variant.price : null

    // Multiply the compare at price and the price.
    const finalCompareAtPrice = compareAtPrice ? compareAtPrice * defaultQuantity : null
    const finalPrice = price ? price * defaultQuantity : null

    // Set variant availability.
    handleSelectedVariantAvailability()

    // Get compare at price of variant.
    addButton.updatePrice(finalPrice, finalCompareAtPrice)
  }
}
